import { useMemo } from 'react';
import { formatOptions, findSelectedOption } from '../utils/autoCompleteHelpers';

export const useAutoCompleteSelect = ({ options, value, onChange }) => {
  const formattedOptions = useMemo(() => formatOptions(options), [options]);
  const selectedOption = useMemo(() => findSelectedOption(formattedOptions, value), [formattedOptions, value]);

  const handleChange = (option) => {
    if (onChange) {
      onChange(
        {
          target: {
            value: option ? option.value : null,
          },
        },
        option
      );
    }
  };

  return {
    formattedOptions,
    selectedOption,
    handleChange,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/AutoCompleteSelect/hooks/useAutoCompleteSelect.js